import { useEffect } from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';
import { useBrand } from './orbit/brand/BrandProvider';

/**
 * Sync'd den URL-Slug mit BrandProvider. Lebt zwischen ProtectedRoute
 * (Auth-Gate) und den Brand-Subroute-Pages.
 */
export function BrandShellSync() {
  const { brandSlug } = useParams();
  const brand = useBrand();

  useEffect(() => {
    if (!brandSlug) return;
    if (brand.currentBrand?.slug === brandSlug) return;
    brand.setCurrentBrandSlug(brandSlug);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [brandSlug]);

  const slugIsKnown = brand.brands.some((b) => b.slug === brandSlug);
  if (!slugIsKnown) return <Navigate to="/" replace />;

  return <Outlet />;
}
